$(document).ready(function() {    
  const url = new URL(window.location.href);
  const params = url.searchParams;

  const modelist = params.getAll('mode')
  const result = modelist.some((t) => t === 'headeroff');
  if(result) {
    //console.log('headerオフ');
    $('.header__wrapper').hide();
    $(".site-footer-wrapper").hide();
  } else {
    //console.log('header通常');
    $('.header__wrapper').show();
    $(".site-footer-wrapper").show();
  }
});


$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

$(document).ready(function () {
  $(".craft_accordion_ttl").click(function () {
    var item = $(this).next(".craft_accordion_item");
    if (item.is(":visible")) {
      item.slideUp();
      $(this).removeClass("open").addClass("close");
    } else {
      item.slideDown();
      $(this).removeClass("close").addClass("open");
    }
  });  
});

$(".fvSp_slide").slick({
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false,
  autoplay: true,
  loop: true,
  dots: false,
  arrows: false,
  fade: true,
  speed: 1000,
  autoplaySpeed: 500,
});

$(".fv_box_right").slick({
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false,
  autoplay: true,
  loop: true,
  dots: false,
  arrows: false,
  fade: true,
  speed: 1000,
  autoplaySpeed: 500,
});

$(".section2_slide").slick({
    autoplay: true,
    dots: true,
    arrows: true,
    infinite: true,
    pauseOnHover: false,
    centerMode: true,
    speed: 500,
    variableWidth: true
});

setInterval(function () {
    var index = $('.like_box_right .item').index($('.like_box_right .item.active'));
    var next_num = index + 1;
    if (next_num === $('.like_box_right .item').length) {
        next_num = 0;
    }
    $('.like_box_right .item.active').removeClass('active');
    $('.like_box_right .item').eq(next_num).addClass('active');
}, 5000);
$('.like_box_right .item').eq(0).addClass('active');

//accordion
$(function () {
  $(".accordion_contents_item").click(function () {
    var $answer = $(this).find(".answer");

    if ($answer.hasClass("open")) {
      $answer.removeClass("open");
      $answer.slideUp();
      $(this).find("span").text("+");
    } else {
      $answer.addClass("open");
      $answer.slideDown();
      $(this).find("span").text("-");
    }
  });
});

//追従CTA
$(function () {
  var cta = $(".footer_cta");
  var threshold = 500;
  var isVisible = false;

  cta.hide();

  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > threshold) {
      cta.fadeIn();
      isVisible = true;
    } else {
      cta.fadeOut();
      isVisible = false;
    }
  });
});

$(function () {
  var footerLine = $(".footer_line");
  var threshold = 500;
  var isVisible = false;

  footerLine.hide();

  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > threshold) {
      footerLine.fadeIn();
      isVisible = true;
    } else {
      footerLine.fadeOut();
      isVisible = false;
    }
  });
});

$(".explainSp_box_right_bottom").slick({
  autoplay: true,
  autoplaySpeed: 1500,
  fade: true,
  speed: 1500,
  dots: false,
  arrows: false,
});

$(".explain_box_left").slick({
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 1500,
  fade: true,
  dots: false,
  arrows: false,
});

function sliderSetting(){
  var width = $(window).width();

  if(width <= 1023){
    // SP
    $(".thought_box").not('.slick-initialized').slick({
      pauseOnHover: false,
      pauseOnFocus: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      dotsClass: "thought_dots",
      centerMode: true,
    });
  } else {
    // pcの場合
    $(".thought_box.slick-initialized").slick('unslick');
  }
}
sliderSetting();

$(window).resize(function() {
  sliderSetting();
});
